var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLerning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M79.2,438.4C124.8,481.6,186,508,254,508s129.2-26.4,174.8-69.6H79.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F9B54C"
    },
    cx: 254,
    cy: 240.8,
    rx: 26.4,
    ry: 45.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M347.2,392c4.4-18,7.2-36,7.2-52.8c0-71.2-44.8-93.2-100.4-93.2c-55.2,0-100.4,21.6-100.4,93.2 c0,16.8,2.4,34.8,7.2,52.8H347.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M280,238.4c0,0-15.2,9.2-26,9.2l14,30.4l20-28.4L280,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228,238.4c0,0,15.2,9.2,26,9.2L240,278l-20-28.4L228,238.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M327.2,111.2c0,42.4-32.8,101.6-73.2,101.6s-73.2-59.2-73.2-101.6s32.8-60.8,73.2-60.8 S327.2,68.8,327.2,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M308.4,153.6c0,43.2-24.4,78-54.4,78s-54.4-34.8-54.4-78c0-25.6,8.8-48.4,22-62.8 c9.6,9.6,21.2,18.8,34.4,26.8c17.6,10.8,35.2,18.4,51.2,22.8C308,144.8,308.4,149.2,308.4,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M351.6,437.6H156.4c-6.8,0-12.8-3.2-13.6-7.6l-24.4-120c-1.2-6.4,4.4-11.6,12.8-11.6h245.6 c8.4,0,14,5.2,12.8,11.6l-24.4,120C364.4,434,358.4,437.6,351.6,437.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2B3B4E"
    },
    cx: 254,
    cy: 362.4,
    rx: 30,
    ry: 12.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLerning);
export default __webpack_public_path__ + "static/media/lerning.a25fa62b82fccea4e0af497079caef02.svg";
export { ForwardRef as ReactComponent };